import { render, staticRenderFns } from "./commonMoralStudent.vue?vue&type=template&id=ae3dbf5e&scoped=true"
import script from "./commonMoralStudent.vue?vue&type=script&lang=js"
export * from "./commonMoralStudent.vue?vue&type=script&lang=js"
import style0 from "./commonMoralStudent.vue?vue&type=style&index=0&id=ae3dbf5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3dbf5e",
  null
  
)

export default component.exports